<template>
    <div>
      <!-- <p @click="chartActive = !chartActive">bbbb</p> -->
  <LineChartGenerator
    v-if="chartActive"
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="'line1'"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
    </div>
</template>

<script>
import moment from 'moment/src/moment'
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
} from 'chart.js'

import zoomPlugin from 'chartjs-plugin-zoom'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  zoomPlugin
)
export default {
  name: 'BarChart',
  components: {
    LineChartGenerator
  },
  props: {
    titlename: {
      type: String,
      default: 'none'
    },
    datachart: {
      type: Array,
      default: () => []
    },
    chartId: {
      type: String,
      default: 'line-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'labels'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 200
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },
  mounted () {
    if (this.$route.query.type === 'SBMPTN') {
      this.chartOptions.scales.y.ticks.stepSize = 100
      this.chartOptions.scales.y.max = 1000
      this.chartOptions.scales.y.min = 0
    } else {
      this.chartOptions.scales.y.ticks.stepSize = 2
      this.chartOptions.scales.y.max = 160
      this.chartOptions.scales.y.min = 0
    }
    let wrapper = this.datachart
    wrapper.forEach(element => {
      if (element.score < 0) {
        this.chartOptions.scales.y.ticks.stepSize = 2
        this.chartOptions.scales.y.min = element.score + -10
      }
      if (element.score > 100 && this.$route.query.type !== 'SBMPTN') this.chartOptions.scales.y.max = element.score + 50
      else if (element.score > 1000 && this.$route.query.type === 'SBMPTN') this.chartOptions.scales.y.max = element.score + 100
      this.chartData.labels.push(element.name)
      this.chartData.datasets[0].label = this.titlename
      this.chartData.datasets[0].data.push(element.score)
    })
  },
  methods: {
    detailHasil (item) {
      localStorage.identifier = item + '_0000000000000'
      this.$store.dispatch('funcGetDetailResult', item + '_0000000000000').then((response) => {
        let gg = response.data
        gg.title = response.data.name
        gg.identifier = response.data.result_identifier
        sessionStorage.setItem('groupResults', JSON.stringify([gg]))
        this.$router.push('/result/' + item)
      }).catch(err => {
        this.toastNotif = true
      })
    },
    conv (index) {
      let toint = Number(this.datachart[index].date)
      var converted = moment.unix(toint).format('DD-MM-YYYY')
      return '(' + converted + ')'
    },
    ellipsisConv (str) {
      if (str.length > 30) {
        return str.substr(0, 10) + '...' + str.substr(str.length - 5, str.length)
      }
      return str
    },
    clickedss (index) {
      console.log(index)
    },
    showPopup (item) {
      console.log('sldkfj')
      this.popupDetail = true
    },
    conspopup (val) {
      document.getElementById('tooltipHideShow').outerHTML = ''
      this.$emit('showDialog', val)
    }
  },
  destroyed () {
    document.getElementById('tooltipHideShow').outerHTML = ''
  },
  data () {
    return {
      chartActive: true,
      popupDetail: false,
      selectedData: { name: '', score: '', group_id: null, date: null },
      toastNotif: false,
      chartData: {
        labels: [
        ],
        datasets: [
          {
            label: '',
            backgroundColor: '#f87979',
            borderColor: 'rgb(255, 183, 183)',
            data: [],
            pointRadius: 5,
            tension: 0.5
          }
        ]
      },
      chartOptions: {
        onClick: (evt, element) => {
          if (element.length > 0) {
            try {
              var ind = element[0].index
              const ctx = this
              this.conspopup(this.datachart[ind])

              ctx.popupDetail = true
              ctx.selectedData = this.datachart[ind]
            } catch (error) {
              console.log(error)
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            ticks: {
              display: false
            },
            grid: {
              display: false
            }
          },
          y: {
            ticks: {
              stepSize: 10
            },
            min: 0,
            max: 1000,
            grid: {
              display: false
            }
          }
        },
        plugins: {
          legend: {
            enabled: false,
            display: false
          },
          tooltip: {
            enabled: false,
            position: 'nearest',
            external: (context) => {
              let tooltipEl = document.getElementById('chartjs-tooltip')
              if (!tooltipEl) {
                tooltipEl = document.createElement('div')
                tooltipEl.id = 'chartjs-tooltip'
                tooltipEl.innerHTML = '<table></table>'
                document.body.appendChild(tooltipEl)
              }
              const tooltipModel = context.tooltip
              if (tooltipModel.opacity === 0) {
                tooltipEl.style.opacity = '0'
                return
              }

              tooltipEl.classList.remove('below', 'no-transform')

              if (tooltipModel.body) {
                const dataFromCurrentElement = tooltipModel.dataPoints[0]
                const currentElement = dataFromCurrentElement.dataIndex
                const formattedValue = dataFromCurrentElement.formattedValue.trim()
                const currentDataToShow = 111
                const innerHtml = `
                        <div id="tooltipHideShow" style="border-collapse: separate; text-align:center; padding: 10px; overflow: hidden; border-radius: 10px; box-shadow: 0 6px 12px rgba(0,0,0,.175);background: #ffffff;">
                            <div style="color:#8E9196; font-size: 18px;">
                            ${this.ellipsisConv(context.tooltip.dataPoints[0].label)}
                            </div>
                            <div style="color:#8E9196;">
                            ${this.conv(context.tooltip.dataPoints[0].dataIndex)}
                            </div>
                            <div style="font-size:24px; color:#3CB54A; font-weight: bold;">
                              ${context.tooltip.dataPoints[0].formattedValue}
                            </div>
                            
                         </div>
                    `

                tooltipEl.querySelector('table').innerHTML = innerHtml
              }

              const position = context.chart.canvas.getBoundingClientRect()
              tooltipEl.style.opacity = '1'
              tooltipEl.style.position = 'absolute'
              tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px'
              tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px'
              tooltipEl.style.padding = tooltipModel.padding + 'px ' + tooltipModel.padding + 'px'
              tooltipEl.style.pointerEvents = 'none'
            }
          },
          zoom: {
            pan: {
              enabled: true
            },
            limits: {
              y: { min: -200, max: 1000 }
            },
            zoom: {
              wheel: {
                enabled: true
              },
              pinch: {
                enabled: true
              },
              mode: 'xy'

            }
          }
        }
      }
    }
  }
}
</script>
